import { getContext } from 'redux-saga/effects';
export function* setHashCookie(hash) {
    const cookies = yield getContext('cookies');
    cookies.set('hash', hash, {
        path: '/aid/integration'
    });
}
export function* clearHashCookie() {
    const cookies = yield getContext('cookies');
    cookies.remove('hash', {
        path: '/aid/integration'
    });
}
export function getRedirectUrl(returnUrl) {
    const url = new URL(returnUrl);
    const { searchParams } = url;
    return searchParams.get('redirect_uri');
}
